import React, { createContext, useContext } from 'react';
export type CTAMode = 'whatsapp' | 'scroll';
export interface CTAConfig {
  mode: CTAMode;
  /** If provided, overrides the button's children text uniformly. */
  label?: string;
  /** Element id to scroll to when mode === 'scroll'. */
  target?: string;
}
const CTAContext = createContext<CTAConfig>({
  mode: 'whatsapp'
});
export const CTAProvider: React.FC<{
  config: CTAConfig;
  children: React.ReactNode;
}> = ({
  config,
  children
}) => {
  return <CTAContext.Provider value={config} data-id="element-22">{children}</CTAContext.Provider>;
};
export const useCTA = () => useContext(CTAContext);